import { PASSWORD_RULES } from "../constants/passwordConstants";

/**
 * ==========================================================
 * Validate Password
 * ==========================================================
 */

export const validatePassword = (password) => {

    const errors = [];

    if (!password) {

        errors.push(
            "Password is required."
        );

        return errors;

    }

    if (

        password.length < PASSWORD_RULES.MIN_LENGTH

    ) {

        errors.push(

            `Password must be at least ${PASSWORD_RULES.MIN_LENGTH} characters.`

        );

    }

    if (

        password.length > PASSWORD_RULES.MAX_LENGTH

    ) {

        errors.push(

            `Password cannot exceed ${PASSWORD_RULES.MAX_LENGTH} characters.`

        );

    }

    if (

        PASSWORD_RULES.REQUIRE_UPPERCASE &&

        !/[A-Z]/.test(password)

    ) {

        errors.push(

            "Password must contain at least one uppercase letter."

        );

    }

    if (

        PASSWORD_RULES.REQUIRE_LOWERCASE &&

        !/[a-z]/.test(password)

    ) {

        errors.push(

            "Password must contain at least one lowercase letter."

        );

    }

    if (

        PASSWORD_RULES.REQUIRE_NUMBER &&

        !/[0-9]/.test(password)

    ) {

        errors.push(

            "Password must contain at least one number."

        );

    }

    if (

        PASSWORD_RULES.REQUIRE_SPECIAL &&

        !/[!@#$%^&*(),.?":{}|<>_\-+=/\\[\]]/.test(password)

    ) {

        errors.push(

            "Password must contain at least one special character."

        );

    }

    return errors;

};